// extracted by mini-css-extract-plugin
export default {"label":"style_label__vkEJM","c":"style_c__5byqo","e":"style_e__tjYHX","icon":"style_icon__kZH9j"};